
import React from 'react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ 
  error, 
  resetErrorBoundary 
}) => {
  const { toast } = useToast();
  
  const handleReportError = () => {
    // In a production app, you might want to send this error to a reporting service
    console.error('Reported error:', error);
    
    toast({
      title: "Error reported",
      description: "Thank you for reporting this issue. We'll look into it.",
      variant: "default",
    });
  };
  
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-12 bg-gradient-to-b from-mono-charcoal to-mono-eerieBlack">
      <div className="max-w-md w-full bg-mono-eerieBlack/90 border border-mono-slateGray/20 rounded-lg p-6 shadow-xl">
        <h2 className="text-xl font-semibold text-mono-platinum mb-4">Something went wrong</h2>
        <p className="text-mono-frenchGray mb-6">
          We've encountered an unexpected error. You can try refreshing the page or returning to the home page.
        </p>
        
        <div className="space-y-4">
          <Button 
            onClick={resetErrorBoundary}
            className="w-full"
            variant="default"
          >
            Try again
          </Button>
          
          <Button 
            onClick={() => window.location.href = '/'}
            className="w-full"
            variant="outline"
          >
            Go to home page
          </Button>
          
          <Button 
            onClick={handleReportError}
            className="w-full"
            variant="ghost"
          >
            Report this issue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
